import * as React from "react";

function SvgFunnelFox(props, ref) {
  return (
    <svg
      id="FunnelFox_svg__Layer_1"
      xmlns="http://www.w3.org/2000/svg"
      x={0}
      y={0}
      viewBox="0 0 137 137"
      xmlSpace="preserve"
      enableBackground="new 0 0 137 137"
      width="1em"
      height="1em"
      {...{ ...props, ref }}
    >
      <style>
        {
          ".FunnelFox_svg__st2,.FunnelFox_svg__st7{fill-rule:evenodd;clip-rule:evenodd;fill:#fff}.FunnelFox_svg__st7{fill:#d57e56}.FunnelFox_svg__st14{fill:none;stroke:#d57e56;stroke-width:3.0698;stroke-linecap:round;stroke-linejoin:round}"
        }
      </style>
      <g id="FunnelFox_svg__Logo_dark">
        <g id="FunnelFox_svg__Fox" transform="translate(34 13)">
          <g id="FunnelFox_svg__Right-Ear" transform="translate(3.516)">
            <g id="FunnelFox_svg__Path-22">
              <linearGradient
                id="FunnelFox_svg__path-2_00000134227782569807223870000001544725216519433869_"
                gradientUnits="userSpaceOnUse"
                x1={-696.617}
                y1={585.896}
                x2={-696.168}
                y2={584.801}
                gradientTransform="matrix(35.5066 0 0 -44.9724 24727.736 26333.525)"
              >
                <stop offset={0} stopColor="#ffce7a" />
                <stop offset={1} stopColor="#fc8333" />
              </linearGradient>
              <path
                id="FunnelFox_svg__path-2_00000129913786526654013320000018138900066233675945_"
                d="M-.4 45.9C-11.1 32-15.4 17-13.3 1c12.6.2 24.2 5.6 35 16.1L-.4 45.9z"
                fillRule="evenodd"
                clipRule="evenodd"
                fill="url(#FunnelFox_svg__path-2_00000134227782569807223870000001544725216519433869_)"
              />
            </g>
            <defs>
              <filter
                id="FunnelFox_svg__Adobe_OpacityMaskFilter"
                filterUnits="userSpaceOnUse"
                x={-15.1}
                y={0.2}
                width={25.9}
                height={46}
              >
                <feColorMatrix values="1 0 0 0 0 0 1 0 0 0 0 0 1 0 0 0 0 0 1 0" />
              </filter>
            </defs>
            <mask
              maskUnits="userSpaceOnUse"
              x={-15.1}
              y={0.2}
              width={25.9}
              height={46}
              id="FunnelFox_svg__mask-3_00000093861717610201525850000002664559979464351900_"
            >
              <g filter="url(#FunnelFox_svg__Adobe_OpacityMaskFilter)">
                <path
                  id="FunnelFox_svg__path-2_00000073707412915259853120000015574276720347956871_"
                  className="FunnelFox_svg__st2"
                  d="M-.4 45.9C-11.1 32-15.4 17-13.3 1c12.6.2 24.2 5.6 35 16.1L-.4 45.9z"
                />
              </g>
            </mask>
            <path
              id="FunnelFox_svg__Path-52"
              d="M-14.7.2c9.8 4.5 18.3 12.6 25.5 24.3L-.5 46.3C-11.8 33.2-16.5 17.8-14.7.2z"
              mask="url(#FunnelFox_svg__mask-3_00000093861717610201525850000002664559979464351900_)"
              fillRule="evenodd"
              clipRule="evenodd"
              fill="#d57e56"
            />
            <defs>
              <filter
                id="FunnelFox_svg__Adobe_OpacityMaskFilter_00000008118681290693446710000017560248811121288632_"
                filterUnits="userSpaceOnUse"
                x={-2.5}
                y={7.1}
                width={26.8}
                height={38.9}
              >
                <feColorMatrix values="1 0 0 0 0 0 1 0 0 0 0 0 1 0 0 0 0 0 1 0" />
              </filter>
            </defs>
            <mask
              maskUnits="userSpaceOnUse"
              x={-2.5}
              y={7.1}
              width={26.8}
              height={38.9}
              id="FunnelFox_svg__mask-3_00000128466322780713946010000003363419244250579610_"
            >
              <g filter="url(#FunnelFox_svg__Adobe_OpacityMaskFilter_00000008118681290693446710000017560248811121288632_)">
                <path
                  id="FunnelFox_svg__path-2_00000132049961712453250040000004787141658208666804_"
                  className="FunnelFox_svg__st2"
                  d="M-.4 45.9C-11.1 32-15.4 17-13.3 1c12.6.2 24.2 5.6 35 16.1L-.4 45.9z"
                />
              </g>
            </mask>
            <path
              id="FunnelFox_svg__Path-54"
              d="M-2.4 46C-2.7 26.2 3.4 13.2 16 7.1l8.4 7.2L-2.4 46z"
              opacity={0.08}
              mask="url(#FunnelFox_svg__mask-3_00000128466322780713946010000003363419244250579610_)"
              fillRule="evenodd"
              clipRule="evenodd"
              enableBackground="new"
            />
          </g>
          <g id="FunnelFox_svg__Left-Ear" transform="translate(70.323 2.628)">
            <g id="FunnelFox_svg__Group-63" transform="translate(.257 .06)">
              <g
                id="FunnelFox_svg__Path-22_00000058547701698955854230000012835626902044374656_"
                transform="scale(-1 1) rotate(-3 0 751.59)"
              >
                <linearGradient
                  id="FunnelFox_svg__path-4_00000044177827676813385580000014652689745581676473_"
                  gradientUnits="userSpaceOnUse"
                  x1={-801.815}
                  y1={584.111}
                  x2={-801.366}
                  y2={583.016}
                  gradientTransform="matrix(-35.3414 -1.8522 2.382 -45.4507 -29710.815 25048.07)"
                >
                  <stop offset={0} stopColor="#ffce7a" />
                  <stop offset={1} stopColor="#fc8333" />
                </linearGradient>
                <path
                  id="FunnelFox_svg__path-4_00000141436389420839903870000002779773820829293235_"
                  d="M8.3 46.8C19.6 33.1 24.7 18.1 23.4 2 10.9 1.9-1 6.9-12.3 16.8l20.6 30z"
                  fillRule="evenodd"
                  clipRule="evenodd"
                  fill="url(#FunnelFox_svg__path-4_00000044177827676813385580000014652689745581676473_)"
                />
              </g>
            </g>
            <path
              id="FunnelFox_svg__Path-2"
              className="FunnelFox_svg__st7"
              d="M23.7 2.2c.4 17.2-4.1 31.3-13.3 42.2-1.4-4.6-2.5-8.1-3.5-10.3s-2.6-5-4.7-8.4C9.4 12.9 16.5 5.1 23.7 2.2z"
            />
            <path
              id="FunnelFox_svg__Path-3"
              d="M-10.2 15.5c1.8-1.5 4-3.3 6.1-4.7C4.7 16 11 25 14.8 37.9l-4.6 7C6.1 29.7-.7 19.9-10.2 15.5z"
              fillRule="evenodd"
              clipRule="evenodd"
              fillOpacity={0.08}
            />
          </g>
          <g id="FunnelFox_svg__Face" transform="translate(0 7.008)">
            <g id="FunnelFox_svg__Face-Shape" transform="translate(.158 .007)">
              <g id="FunnelFox_svg__Combined-Shape">
                <linearGradient
                  id="FunnelFox_svg__path-7_00000064352159661423497350000013967123858164421285_"
                  gradientUnits="userSpaceOnUse"
                  x1={-705.826}
                  y1={584.236}
                  x2={-705.166}
                  y2={583.256}
                  gradientTransform="matrix(107.2513 0 0 -101.0777 75701.89 59062.352)"
                >
                  <stop offset={0} stopColor="#ffce7a" />
                  <stop offset={1} stopColor="#ff9e5d" />
                </linearGradient>
                <path
                  id="FunnelFox_svg__path-7_00000026128007300394093230000009956640631500666031_"
                  d="M26.2 6.7c-2.1-3.2-1.3-5.3 2.3-6.3C32-.5 36.4 1 41.6 5h.3c-1.1-2.6-.4-4.1 2-4.6S51.4 3 59.3 9.6c7.5 3.8 14.2 10.2 18.3 20.4 8.4 21.1 3.7 35.1 14.7 50.1L90 83.9l3.4 2.3c-20.2 12-40 16.8-59.3 14.5-19.3-2.4-35.3-10.5-48-24.4l3.7-1.2-2.1-2.9C-4.6 59.9-.1 49.5 1.2 41c2-12.9 11.1-30.1 25-34.3z"
                  fillRule="evenodd"
                  clipRule="evenodd"
                  fill="url(#FunnelFox_svg__path-7_00000064352159661423497350000013967123858164421285_)"
                />
              </g>
              <defs>
                <filter
                  id="FunnelFox_svg__Adobe_OpacityMaskFilter_00000024681946441398323110000002235230108376585663_"
                  filterUnits="userSpaceOnUse"
                  x={8.3}
                  y={54.1}
                  width={61}
                  height={50.1}
                >
                  <feColorMatrix values="1 0 0 0 0 0 1 0 0 0 0 0 1 0 0 0 0 0 1 0" />
                </filter>
              </defs>
              <mask
                maskUnits="userSpaceOnUse"
                x={8.3}
                y={54.1}
                width={61}
                height={50.1}
                id="FunnelFox_svg__mask-8_00000183251142736847397300000002184019689971916449_"
              >
                <g filter="url(#FunnelFox_svg__Adobe_OpacityMaskFilter_00000024681946441398323110000002235230108376585663_)">
                  <path
                    id="FunnelFox_svg__path-7_00000008148101891684106480000001855697463142730376_"
                    className="FunnelFox_svg__st2"
                    d="M26.2 6.7c-2.1-3.2-1.3-5.3 2.3-6.3C32-.5 36.4 1 41.6 5h.3c-1.1-2.6-.4-4.1 2-4.6S51.4 3 59.3 9.6c7.5 3.8 14.2 10.2 18.3 20.4 8.4 21.1 3.7 35.1 14.7 50.1L90 83.9l3.4 2.3c-20.2 12-40 16.8-59.3 14.5-19.3-2.4-35.3-10.5-48-24.4l3.7-1.2-2.1-2.9C-4.6 59.9-.1 49.5 1.2 41c2-12.9 11.1-30.1 25-34.3z"
                  />
                </g>
              </mask>
              <path
                id="FunnelFox_svg__Path-47"
                d="M16.3 97.9c-5.9-3.5-8-6.7-8-13.2 0-10 18.8-30.5 29.7-30.5s23.8 12.1 30.1 29.2c2.9 8 .3 13-5.8 17L37 104.2l-20.7-6.3z"
                opacity={0.5}
                mask="url(#FunnelFox_svg__mask-8_00000183251142736847397300000002184019689971916449_)"
                fillRule="evenodd"
                clipRule="evenodd"
                fill="#fff"
                enableBackground="new"
              />
              <defs>
                <filter
                  id="FunnelFox_svg__Adobe_OpacityMaskFilter_00000085961912645480868910000012490843500448354488_"
                  filterUnits="userSpaceOnUse"
                  x={-5.4}
                  y={-2.6}
                  width={67.2}
                  height={60.3}
                >
                  <feColorMatrix values="1 0 0 0 0 0 1 0 0 0 0 0 1 0 0 0 0 0 1 0" />
                </filter>
              </defs>
              <mask
                maskUnits="userSpaceOnUse"
                x={-5.4}
                y={-2.6}
                width={67.2}
                height={60.3}
                id="FunnelFox_svg__mask-8_00000096763132007423281410000013033620908029030788_"
              >
                <g filter="url(#FunnelFox_svg__Adobe_OpacityMaskFilter_00000085961912645480868910000012490843500448354488_)">
                  <path
                    id="FunnelFox_svg__path-7_00000053509841913642139140000009661393505925949572_"
                    className="FunnelFox_svg__st2"
                    d="M26.2 6.7c-2.1-3.2-1.3-5.3 2.3-6.3C32-.5 36.4 1 41.6 5h.3c-1.1-2.6-.4-4.1 2-4.6S51.4 3 59.3 9.6c7.5 3.8 14.2 10.2 18.3 20.4 8.4 21.1 3.7 35.1 14.7 50.1L90 83.9l3.4 2.3c-20.2 12-40 16.8-59.3 14.5-19.3-2.4-35.3-10.5-48-24.4l3.7-1.2-2.1-2.9C-4.6 59.9-.1 49.5 1.2 41c2-12.9 11.1-30.1 25-34.3z"
                  />
                </g>
              </mask>
              <path
                id="FunnelFox_svg__Path-53"
                d="M-5.4 57.7c14.6-38.2 37-54 67.2-47.4C48-5.2 31.3-6.8 11.6 5.6 4.8 9.8-.9 27.2-5.4 57.7z"
                opacity={0.2}
                mask="url(#FunnelFox_svg__mask-8_00000096763132007423281410000013033620908029030788_)"
                fillRule="evenodd"
                clipRule="evenodd"
                fill="#fff"
                enableBackground="new"
              />
            </g>
            <path
              id="FunnelFox_svg__Mouth"
              className="FunnelFox_svg__st14"
              d="M36.9 83.1c7.2.6 12.1-1.8 14.9-7.2"
            />
            <path
              id="FunnelFox_svg__Nose"
              className="FunnelFox_svg__st7"
              d="M35 61.7h6.3c1.1 0 2 .9 2 2 0 .6-.2 1.1-.7 1.5L39.5 68c-.8.7-2 .7-2.7 0l-3.1-2.8c-.8-.8-.9-2-.2-2.9.3-.4.9-.6 1.5-.6z"
            />
            <path
              id="FunnelFox_svg__Right-Eye"
              className="FunnelFox_svg__st14"
              d="M51.7 50.3c0-2.8 2.3-5.1 5.2-5.1s5.2 2.3 5.2 5.1"
            />
            <path
              id="FunnelFox_svg__Left-Eye"
              className="FunnelFox_svg__st14"
              d="M15.7 50.3c0-2.8 2.3-5.1 5.2-5.1 2.8 0 5.2 2.3 5.2 5.1"
            />
          </g>
        </g>
      </g>
    </svg>
  );
}

export default React.forwardRef(SvgFunnelFox);
